import React from 'react';
import { Pagination } from 'react-bootstrap';

const MAX_BOTOES = 5;

const PaginacaoGrid = ({
  paginaAtual,
  totalRegistros,
  itensPorPagina,
  onPaginaChange,
}) => {
  const totalPaginas = Math.max(1, Math.ceil(totalRegistros / itensPorPagina));
  const inicioRegistro = totalRegistros > 0
    ? ((paginaAtual - 1) * itensPorPagina) + 1
    : 0;
  const fimRegistro = Math.min(paginaAtual * itensPorPagina, totalRegistros);

  if (totalRegistros === 0) {
    return null;
  }

  const itens = [];
  let inicio = Math.max(1, paginaAtual - Math.floor(MAX_BOTOES / 2));
  let fim = Math.min(totalPaginas, inicio + MAX_BOTOES - 1);
  inicio = Math.max(1, fim - MAX_BOTOES + 1);

  itens.push(
    <Pagination.First
      key="first"
      disabled={paginaAtual === 1}
      onClick={() => onPaginaChange(1)}
    />
  );
  itens.push(
    <Pagination.Prev
      key="prev"
      disabled={paginaAtual === 1}
      onClick={() => onPaginaChange(paginaAtual - 1)}
    />
  );

  if (inicio > 1) {
    itens.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
  }

  for (let pagina = inicio; pagina <= fim; pagina += 1) {
    itens.push(
      <Pagination.Item
        key={pagina}
        active={pagina === paginaAtual}
        onClick={() => pagina !== paginaAtual && onPaginaChange(pagina)}
      >
        {pagina}
      </Pagination.Item>
    );
  }

  if (fim < totalPaginas) {
    itens.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
  }

  itens.push(
    <Pagination.Next
      key="next"
      disabled={paginaAtual === totalPaginas}
      onClick={() => onPaginaChange(paginaAtual + 1)}
    />
  );
  itens.push(
    <Pagination.Last
      key="last"
      disabled={paginaAtual === totalPaginas}
      onClick={() => onPaginaChange(totalPaginas)}
    />
  );

  return (
    <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top">
      <small className="text-muted">
        Mostrando {inicioRegistro} até {fimRegistro} de {totalRegistros} registros
      </small>
      {totalPaginas > 1 && (
        <Pagination size="sm" className="mb-0">
          {itens}
        </Pagination>
      )}
    </div>
  );
};

export default PaginacaoGrid;
